export default ngModule => {

  ngModule.factory('Auth', function (AonApi, $q, $http, $cookies) {
    // We aren't currently concerned about properly authenticating users so doing simplistic once of login on a code
    // and then storing cookies saying they are authorised. Easily bypassed (ie. manually set cookie).

    // Everything is promised based in case we need to swap this out for some real auth.
    const authCheckCookieName = 'aoncompare.authorised';
    class Auth {

      /**
       * Check if current session is authorised. Simply checks for presence of cookie.
       *
       * @returns {Promise}
       */
      check() {
        const deferred = $q.defer();
        if ($cookies[authCheckCookieName]) {
          deferred.resolve();
        } else {
          deferred.reject({code: 401});
        }
        return deferred.promise;
      }

      /**
       * Login with specified code
       *
       * @param code
       * @returns {Promise}
       */
      login(code) {
        const deferred = $q.defer(),
          success = () => {
            $cookies[authCheckCookieName] = true;
            deferred.resolve();
          },
          error = () => {
            $cookies[authCheckCookieName] = false;
            deferred.reject();
          };
        AonApi.post('authorise', {code}).then(success, error);
        return deferred.promise;
      }

      zohoLogin() {
        $cookies[authCheckCookieName] = true;
      }
    }

    return new Auth();

  });


}



// WEBPACK FOOTER //
// ./src/services/auth-service.js